module.exports = "<mat-form-field>\n    <input matInput [matDatepicker]=\"picker\" placeholder=\"{{label}}\">\n    <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\n    <mat-datepicker #picker startView=\"day\"></mat-datepicker>\n    <!--<mat-datepicker #picker startView=\"day\" [startAt]=\"startDate\"></mat-datepicker>-->\n</mat-form-field>\n\n"


//////////////////
// WEBPACK FOOTER
// /app/src/SharedModule/DatepickerComponent/datepicker.component.html
// module id = ../../../../../src/SharedModule/DatepickerComponent/datepicker.component.html
// module chunks = main